<template>
    
    <div class="container">
        <div class="row col-md-9 mx-auto my-5">
            <h2 class="mt-5" style="font-weight: bold;">Nabaco AI Assistant</h2>
            <div class="row mt-5">
                <h5 class="mt-3">
                    Nabaco Trading AI Assistant is designed to help you make more informed and successful decisions in the fast-paced and complex world of financial trading. By leveraging real-time data analysis and accurate forecasting, this assistant empowers you to increase profitability and reduce trading risks.
                    <br>
                    <br>
                    <br>
                    Click here to use the services
                    <br>
                    <br>
                    <button class="btn-gold my-2">
                      <a href="https://survey.porsline.ir/s/sP04J912" style="color: black; text-decoration: none;">Test link</a>
                    </button>
                    <br>
                    <br>
                    <br>
                    Trade smarter than ever with Nabaco's AI Trading Assistant. <a href="../sign-up">Sign up now</a> and harness the power of AI!
                </h5>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style scoped>
    *{
        direction: ltr;
    }
</style>